<template>
  <div class="pr-10 px-4">
    <v-row>
      <v-col>
        <div class="primary1--text headline font-weight-bold">
          TABELAS DE DOMÍNIOS
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-row align="center">
          <v-col cols="6">
            <validation-provider name="tipoTabela" ref="tipoTabela" mode="passive" rules="required" v-slot="{ errors }">
              <autocomplete-cadu
                :errorMessage="errors[0]"
                :items="items.map((el) => el.nome)"
                title="Tabela"
                v-model="tipoTabela.nome"
                @index="indexDominios"
              />
            </validation-provider>
          </v-col>
          <v-col cols="auto" class="mt-6 pl-0">
            <button-search @click="verifyCombo" />
          </v-col>
          <v-col cols="5">
            <v-row justify="end" align="center" no-gutters>
              <v-col class="ml-4" cols="auto" v-if="exibeVincularNivelSelo" @click="openVincularNivelSelo">
                <icon name="link" :size="20" style="cursor: pointer;" tooltip="Vincular Nível-Selo" />
              </v-col>
              <v-col class="ml-4" cols="auto" @click="openDownload">
                <icon name="download" :size="20" style="cursor: pointer;" tooltip="Exportar" />
              </v-col>
              <v-col class="ml-4" cols="auto" @click="openImportacao">
                <icon name="upload" :size="20" style="cursor: pointer;" tooltip="Importar" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-2">
          <v-col cols="12">
            <div class="fontColor--text">
              Status da Opção
            </div>
          </v-col>
          <v-col cols="auto mr-2">
            <checkbox-cadu v-model="checkAll" obligatory single value="TODOS" rounded>
              <div slot="text">
                Todos
              </div>
            </checkbox-cadu>
          </v-col>
          <v-col cols="auto" class="mr-2">
            <checkbox-cadu v-model="checkAll" obligatory single value="ATIVO" rounded>
              <div slot="text">
                Ativo
              </div>
            </checkbox-cadu>
          </v-col>
          <v-col cols="auto">
            <checkbox-cadu v-model="checkAll" obligatory single value="INATIVO" rounded>
              <div slot="text">
                Inativo
              </div>
            </checkbox-cadu>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <TabelaGeral
          v-show="openTabela"
          ref="tabelaGeral"
          @ordenacao="populateOrdem"
          :ordemProp="ordem"
          :args="getArgs()"
        />
      </v-col>
    </v-row>

    <overlay-loading v-model="loadingOverlay" />

    <error-modal v-model="error" :errObj="errObj" />

    <ModalImportacao
      v-model="showImportacao"
      :listaTabelas="items"
      ref="modalImportacao"
      @success="importSucessoModal"
    />

    <ModalVincularNivelSelo
      v-model="showVincularNivelSelo"
      ref="refModalVincularNivelSelo"
      @success="niveSucessoModal"
    />

    <SucessoModal
      :genericMessage="messageImport"
      :showSucess="showSucess"
      sucessType="import"
      @close="showSucess = false"
    />
  </div>
</template>

<script>
import ModalImportacao from './Shared/ModalImportacao'
import ModalVincularNivelSelo from './Shared/ModalVincularNivelSelo'

import TipoDominios from '@/services/Dominios/TipoDominios'
import TabelaDominios from '@/services/Dominios/TabelaDominios'

import { ValidationProvider } from 'vee-validate'

import { clone } from 'lodash'
const TabelaGeral = () => import(/* webpackChunkName: "TabelaGeral" */ './Shared/TabelaGeral')
export default {
  components: {
    TabelaGeral,
    ValidationProvider,
    ModalImportacao,
    ModalVincularNivelSelo
  },
  data() {
    return {
      items: [],
      tipoTabela: {
        nome: '',
        valor: ''
      },
      checkAll: ['TODOS'],
      tokenBearer: localStorage.getItem('tokenBearer'),
      loadingOverlay: false,
      error: false,
      errObj: {},
      showImportacao: false,
      showSucess: false,
      showVincularNivelSelo: false,
      messageImport: 'Documento enviado com sucesso!',
      ordenacao: '',
      ordem: 'desc',
      openTabela: false
    }
  },
  beforeMount() {
    this.loadingLista()
  },
  methods: {
    importSucessoModal() {
      this.messageImport = 'Documento enviado com sucesso!'
      this.showImportacao = false
      this.showSucess = true
    },
    niveSucessoModal() {
      this.messageImport = 'Selo atualizado com sucesso!'
      this.showVincularNivelSelo = false
      this.showSucess = true
    },
    openVincularNivelSelo() {
      this.showVincularNivelSelo = true
    },
    async openImportacao() {
      const tipoTabela = clone(this.tipoTabela)
      this.$refs.modalImportacao.start(tipoTabela)
      this.showImportacao = true
    },
    async openDownload() {
      if (await this.verifyResponse()) {
        this.downloadDominios()
      }
    },
    async verifyCombo() {
      this.openTabela = true
      if (await this.verifyResponse()) {
        this.ordem = 'asc'
        this.ordenacao = ''
        this.$refs.tabelaGeral.loadingTabelaDominio(this.getArgs())
      }
    },
    async verifyResponse() {
      let res = await this.$refs.tipoTabela.validate()
      return res.valid
    },
    async loadingLista() {
      const tipoDominio = new TipoDominios(this.tokenBearer, this.$appConfig.config.API)

      try {
        let response = await tipoDominio.getTipoDominios()
        this.items = response.data
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
      }
    },
    indexDominios(index) {
      this.tipoTabela.valor = index > -1 && index !== null ? this.items[index].valor : ''
    },
    populateOrdem(obj) {
      this.ordem = obj.ordem
      this.ordenacao = obj.ordenacao
      this.$refs.tabelaGeral.loadingTabelaDominio(this.getArgs())
    },
    getArgs() {
      let args = this.geradorParams(
        { name: 'status', value: this.checkAll[0] || '' },
        { name: 'tipoDominio', value: this.tipoTabela.valor },
        { name: 'ordenacao', value: this.ordenacao },
        { name: 'direcaoOrdenacao', value: this.ordem }
      )
      return args
    },
    geradorParams(...params) {
      let str = ''
      for (let p of params) {
        if (p.value) {
          str += `${p.name}=${p.value}&`
        }
      }
      if (params.length > 0) {
        str = str.substring(0, str.length - 1)
      }
      return str
    },
    async downloadDominios() {
      this.loadingOverlay = true
      const tabelaDominios = new TabelaDominios(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responseGet = await tabelaDominios.exportarDominios(this.getArgs())
        let content = responseGet.headers['content-disposition']
        const url = window.URL.createObjectURL(new Blob([responseGet.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', content.substring(content.indexOf('"'), content.lastIndexOf('"')))
        document.body.appendChild(link)
        link.click()
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
      }
      this.loadingOverlay = false
    }
  },
  computed: {
    exibeVincularNivelSelo() {
      return this.tipoTabela.valor == 'TIPO_SELO_NIVEL'
    }
  }
}
</script>
